import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Spin, Modal, Row, Col, Button, Card, Divider } from "antd";
import { searchPitchesApi } from "../../../api/search.api";
import PitchList from "../../../components/List/Pitch.list";
import { l, formatNumber } from "../../../libs/localization";
import ErrorModal from "../../../components/ErrorModal";
import PitchGraph from "../../../components/PitchGraph/PitchGraph";
import { getPitchGraphApi } from "../../../api/pitch.api";

const DashboardPitchList = ({ filters, onFiltersChange }) => {
  const [tagMode, setTagMode] = useState(false);

  const pitchesQuery = useQuery({
    queryKey: ["dashboardPitches", filters],
    queryFn: async () => {
      const { page, ...rest } = filters;
      const dataParams = {
        ...rest,
        pageNum: page || 1,
        limit: filters.limit || 10,
      };

      const res = await searchPitchesApi({ data: dataParams });
      return res;
    },
    refetchOnWindowFocus: false,
    placeholderData: (prev) => prev,
  });

  const pitchGraphQuery = useQuery({
    queryKey: ["dashboardPitchGraph", filters.companyIds],
    queryFn: async () => {
      if (!filters.companyIds || filters.companyIds.length === 0) return [];
      const res = await getPitchGraphApi({
        data: { companyIds: filters.companyIds },
      });
      return res;
    },
    enabled: !!filters.companyIds?.length,
    refetchOnWindowFocus: false,
  });

  const onMoreBrandClick = (title, content) => {
    Modal.info({
      title,
      content,
      width: "800px",
    });
  };

  if (pitchesQuery.isError) {
    ErrorModal.show(pitchesQuery.error);
  }

  const resultSearch = pitchesQuery.data || {};
  const pitchList = resultSearch.data || [];
  const total = resultSearch.totalResults;
  const graphData = pitchGraphQuery.data || [];

  const handleOrder = (val) => {
    const orderDir = filters.sort_direction === "asc" ? "desc" : "asc";
    onFiltersChange({
      ...filters,
      sort_key: val,
      sort_direction: val === filters.sort_key ? orderDir : "asc",
      page: 1,
    });
  };

  const orderLabel = (value, key) => {
    const isSelected = filters.sort_key === value;
    return (
      <Button
        type="link"
        className={`${isSelected ? "selected" : ""} searchPage__orders-button`}
        onClick={() => handleOrder(value)}
        style={{ fontWeight: isSelected ? "bold" : "normal" }}
      >
        {key}
        {isSelected && (
          <span className="searchPage__orders-icon">
            {filters.sort_direction === "asc" ? " ▲" : " ▼"}
          </span>
        )}
      </Button>
    );
  };

  return (
    <div className="dashboard-pitch-list">
      {graphData.length > 0 && (
        <div style={{ marginBottom: "20px", marginTop: "10px" }}>
          <PitchGraph data={graphData} />
          <Divider />
        </div>
      )}
      <Row
        align="middle"
        className="searchPage__orders"
        style={{ height: 60, padding: "0 20px" }}
      >
        <Col className="orange-title" style={{ fontWeight: "normal" }}>
          {l("COMMON.ORDER_BY")}
        </Col>
        <Col span={15}>
          {orderLabel("name", l("PAGES.SEARCH.ORDER.NAME"))}
          {orderLabel("start_date", l("PAGES.SEARCH.ORDER.DATE"))}
        </Col>
        <div style={{ marginLeft: "auto" }}>
          <h2
            style={{ fontWeight: "bold", margin: 0 }}
            className="searchPage__orders-button orange-title"
          >
            {l("PAGES.SEARCH.PITCH_FOUND")}{" "}
            <span className="orange-title">{formatNumber(total || 0)}</span>
          </h2>
        </div>
      </Row>
      <PitchList
        pitchList={pitchList}
        total={total}
        onMoreBrandClick={onMoreBrandClick}
        loadingList={pitchesQuery.isFetching}
        tagMode={tagMode}
        pageSize={filters.limit || 10}
        setPageSize={(newSize) =>
          onFiltersChange({ ...filters, limit: newSize, page: 1 })
        }
        page={filters.page || 1}
        setPitchTagPage={(newPage) =>
          onFiltersChange({ ...filters, page: newPage })
        }
        isDashboard={true}
      />
    </div>
  );
};

export default DashboardPitchList;
